import { UseFormBehaviors_ValidationFnType } from 'hooks/useFormBehaviors/useFormBehaviors.types';
import i18next from 'i18next';
import { IEditJaneViewForm } from 'pages/Settings/pages/LocationSettings/PositionsAllocation/RemovePositionModal/views/JaneModal/EditJaneView/EditJaneView.form.context';
import { Jane } from 'types/graphql';
export interface AdditionalPosition {
  position_type: string;
  position_id: number;
}

export interface DestroyedPosition {
  id?: number;
  position_type?: string;
  position_id?: number;
  _destroy?: number;
}
interface PrimaryPositionWithId {
  id: number;
  position_id: number;
  position_type: string;
  _destroy: number;
}

interface PrimaryPositionWithoutId {
  position_id: number;
  position_type: string;
}

export type ConcatenatedPrimaryArray = PrimaryPositionWithId | PrimaryPositionWithoutId;
export type DestroyedAndAddPositionArrays = DestroyedPosition | AdditionalPosition;
export type IHandlePrimaryAndSEcondaryPositions =
  | DestroyedAndAddPositionArrays
  | ConcatenatedPrimaryArray;

export const VALIDATION_position_id: UseFormBehaviors_ValidationFnType<IEditJaneViewForm> = (
  value,
): string => {
  const position_id = value as string[];
  if (position_id.length === 0) return i18next.t(`team_member:MUST_SELECT_AT_LEAST_ONE_POSITION`);
  return '';
};

export const prepareEditPayload = (
  formValues: IEditJaneViewForm,
  data: Jane,
  isSameIds: boolean,
) => {
  const { position_id, selectedSecondaryPositions } = formValues;
  const foundPrimaryPosition = data?.positions.find(
    (position: { id: number; type: string; details: { displayId: number } }) =>
      position.details.displayId === data?.primaryPosition?.details.displayId &&
      position.type === 'primary',
  );
  const handlePrimaryPosition: ConcatenatedPrimaryArray[] =
    String(data.primaryPosition?.details?.id) !== String(position_id)
      ? [
          {
            id: foundPrimaryPosition?.id,
            position_id: Number(foundPrimaryPosition?.details?.id),
            position_type: `${foundPrimaryPosition?.type}`,
            _destroy: 1,
          },
          {
            position_id: Number(position_id[0]),
            position_type: 'primary',
          },
        ]
      : [];
  const secondaryPositionsMapIdsAsNumber: number[] = selectedSecondaryPositions
    .filter((id) => !!id)
    .map(Number);
  const filteredDeleteSecondaryPositions = data.secondaryPositions.filter(
    (position: { details: { displayId: number } }) =>
      !secondaryPositionsMapIdsAsNumber.includes(position.details.displayId),
  );

  const deleteSecondaryPositions: DestroyedPosition[] = filteredDeleteSecondaryPositions.map(
    (position: { id: number; type: string; details: { displayId: number } }) => ({
      id: position.id,
      position_type: position.type ? position.type : 'additional',
      position_id: Number(position.details?.displayId) || Number(position.id),
      _destroy: data?.secondaryPositions.some((item: { id: number }) => item.id === position.id)
        ? 1
        : 0,
    }),
  );

  const filteredAddSecondaryPositions = secondaryPositionsMapIdsAsNumber.filter(
    (id) => !data.secondaryPositions.some((position) => position.details.displayId === id),
  );

  const addSecondaryPositions: AdditionalPosition[] = filteredAddSecondaryPositions.map(
    (secondaryPositionId) => ({
      position_type: 'additional',
      position_id: Number(secondaryPositionId),
    }),
  );

  const handleSecondaryPositions: DestroyedAndAddPositionArrays[] = isSameIds
    ? []
    : [...addSecondaryPositions, ...deleteSecondaryPositions];

  const handlePrimaryAndSecondaryPositions: IHandlePrimaryAndSEcondaryPositions[] = [
    ...handleSecondaryPositions,
    ...handlePrimaryPosition,
  ];
  return {
    jane: {
      employee_positions_attributes: handlePrimaryAndSecondaryPositions,
    },
  };
};
